<template>
  <vs-row>
    <vs-col vs-w="12">
      <h3>
        Mantenedor de Documentos
      </h3>
      <div class="margin-top">
        <br>Estas opciones activas aparecerán en los formularios de la aplicación.
      </div>
      <div v-if="mantenedorDocumentos && !mantenedorDocumentos.length">
        <h5 class="info-documents">
          Pulsa el botón
          <span style="padding: 0 4px;">
              <vs-button color="primary" class="margin-right" size="small" disabled
                         type="border" icon="search" />
            </span>
          para ver los documentos de la categoría
        </h5>
      </div>
    </vs-col>
    <vs-col vs-lg="12" id="listado-opciones">
      <vs-row vs-type="flex" vs-align="space-around" vs-justify="space-around">
        <vs-col class="margin-top" vs-sm="12" vs-lg="6">
          <div class="add-new">
            <h4>Categorías</h4>
            <CheckPermission permission="ED028">
              <vs-button
                v-tooltip="'Agregar categoría'"
                color="primary"
                class="margin-right"
                v-on:click="createOption()"
                type="border"
                icon="playlist_add"
                data-cy="create-option"
              />
            </CheckPermission>
          </div>
          <vs-list class="bg-white margin-top box-options">
            <div
              v-for="category in mantenedorCategorias"
              class="wrap-list-item"
              :key="category.opcionId"
              data-cy="doc-type"
            >
              <ListItemOption
                :option="{...category}"
                :type="'category'"
                :selectedCategory="selectedCategory
                && selectedCategory.opcionId === category.opcionId"/>
            </div>
          </vs-list>
        </vs-col>
        <vs-col
          class="margin-top"
          vs-sm="12"
          vs-lg="6"
        >
          <div class="add-new">
            <h4>Documentos</h4>
            <CheckPermission permission="ED031">
              <vs-button
                v-tooltip="'Agregar documento a categoría'"
                color="primary"
                class="margin-right"
                v-if="selectedCategory.opcionId"
                v-on:click="createOption(selectedCategory)"
                type="border"
                icon="playlist_add"
              />
            </CheckPermission>
          </div>
          <vs-list
            class="bg-white margin-top box-options"
            v-if="mantenedorDocumentos && mantenedorDocumentos.length"
          >
            <div
              v-for="document in mantenedorDocumentos"
              class="wrap-list-item"
              :key="document.opcionId"
            >
              <ListItemOption
                :option="document" :type="'document'"
                :usersCompany="usersCompany"
                :groupsCompany="groupsCompany"
                :category="selectedCategory"
              />
            </div>
          </vs-list>
        </vs-col>
      </vs-row>
    </vs-col>
    <b-modal
      :title="createDocument ? 'Nuevo Documento ' : 'Nueva Categoría '"
      ref="createMood"
      hide-footer
      centered
      no-close-on-backdrop
      size="lg"
    >
      <ManageOption
        @save-option="saveOption"
        :option="option"
        :type="createDocument ? 'document' : 'category'"
      />
    </b-modal>
  </vs-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import ListItemOption from '../components/ListItemOption';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import ManageOption from '@/febos/chile/tools/components/ManageOption';

export default {
  components: { ListItemOption, CheckPermission, ManageOption },
  mixins: [],
  data() {
    return {
      createDocument: false,
      option: {
        extra: {
          uso: {}
        }
      }
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#listado-opciones > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#listado-opciones',
        scale: 0.6
      });
    }
  },
  computed: {
    ...mapGetters('Herramientas', [
      'loading',
      'mantenedorCategorias',
      'mantenedorDocumentos',
      'selectedCategory'
    ]),
    ...mapGetters('Usuario', [
      'usuarioActual'
    ]),
    ...mapGetters('Empresas', [
      'empresa',
      'usersCompany',
      'groupsCompany'
    ])
  },
  methods: {
    ...mapActions('Herramientas', [
      'listCategories',
      'listDocuments',
      'clearDocuments',
      'saveOptions'
    ]),
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getGroupsCompany'
    ]),
    createOption(category) {
      this.createMood = !this.createMood;
      this.option = {
        extra: {
          numInt: false,
          numOf: false,
          uso: {
            contraloria: false,
            tramite: false
          }
        }
      };
      if (category) {
        this.createDocument = true;
        this.option = {
          ...this.option,
          parametroId: `${category.grupoId }.${ category.valor }.item.`,
          grupoId: `${category.grupoId }.${ category.valor }.item`,
          orden: this.mantenedorDocumentos.length + 1
        };
      }
      this.$refs.createMood.show();
    },
    async saveOption() {
      const extra = {
        numOf: this.option.extra.numOf || false,
        numInt: this.option.extra.numInt || false,
        ...this.option.extra
      };

      if ((this.option.valor && this.option.valor !== '')
        && (this.option.descripcion && this.option.descripcion !== '')) {
        const option = {
          valor: this.option.valor,
          descripcion: this.option.descripcion,
          configuradoPor: this.usuarioActual.id,
          referenciaId: this.empresa.id,
          parametroId: this.createDocument
            ? this.option.parametroId + this.option.valor : `tipos.documentos-ed.${ this.option.valor}`,
          orden: this.createDocument ? this.option.orden : this.mantenedorCategorias.length + 1,
          nivel: 0,
          grupoId: this.createDocument ? this.option.grupoId : 'tipos.documentos-ed',
          extra: JSON.stringify(extra)
        };

        await this.saveOptions(option);

        if (Object.keys(this.selectedCategory).length) {
          await this.listDocuments(this.selectedCategory);
        } else {
          await this.listCategories({
            grupoOpcion: 'tipos.documentos-ed',
            deshabilitado: 'si'
          });
        }
        this.createDocument = false;
        if (this.$refs.createMood) {
          this.$refs.createMood.hide();
        }
      } else {
        this.$bvToast.toast(
          'Tienes que colocar una abreviación / descripción',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
      }
    }
  },
  mounted() {
    this.clearDocuments();
    this.listCategories({
      grupoOpcion: 'tipos.documentos-ed',
      deshabilitado: 'si'
    });
    this.getUsersCompany({
      empresaId: this.empresa.id,
      pagina: 1,
      filas: 9999,
      buscarInfoExtra: 'si',
      filtroInfoExtra: 'CARGO'
    });
    this.getGroupsCompany({
      empresaId: this.empresa.id
    });
  }
};
</script>

<style lang="css" scoped>

  .box-button {
    display: flex;
    justify-content: center;
  }

  .margin-top {
    margin-top: 20px;
  }

  .box-options {
    height: 500px;
    overflow-y: scroll;
  }

  .info-documents {
    display: flex;
  }

  .add-new {
    display: flex;
    justify-content: space-evenly;
  }

  .input-edit {
    border: 1px solid #66258324;
    padding: 4px 4px 6px 4px;
    border-radius: 5px;
  }
</style>
